export default __webpack_public_path__ + "static/media/Siddhesh.27f00d3c.jfif";